import { CsvImporter } from '../components/CsvImporter';

export const InvoiceCsvImport = () => <CsvImporter isInvoiceMode />;
